import update from 'immutability-helper';

const selectClubReducer = (state = {failure: false,fetchers: 0}, action) => {
  switch (action.type) {
    case 'CLEAR_CLUBS':
      return update(state, {$unset: ["clubs"]});
    case 'FETCHING_CLUBS':
      return update(state, {'fetchers': {$apply: (x) => {return x + 1;}}});
    case 'FETCH_CLUBS_SUCCESS':
      return update(state, {
          'clubs' : {$set: action.data},
          'fetchers': {$apply: (x) => {return x - 1;}}
      });
    case 'FETCH_CLUBS_FAILED':
      return update(state, {'failure': {$set: true}});
    default:
      return state
  }
}
export default selectClubReducer



// WEBPACK FOOTER //
// ./src/club/reducer.jsx